export const DEFAULT_GRID_COLOR = '#80808010';
export const DEFAULT_ZONE_COLOR = '#80808020';
export const DEFAULT_FLOOR_HEIGHT = 50;

export const PIN_COLOR_ACTIVE = '#FF8900';
export const PIN_COLOR_INACTIVE = '#808080';

export const PIN_MARKER_PATH = [
  {
    x: 8.79078,
    y: 0,
  },
  {
    bezier: [
      {
        x: 6.46343,
        y: 0,
      },
      {
        x: 4.23105,
        y: 0.912681,
      },
      {
        x: 2.58314,
        y: 2.53778,
      },
    ],
  },
  {
    bezier: [
      {
        x: 0.935235,
        y: 4.16288,
      },
      {
        x: 0.00629013,
        y: 6.36784,
      },
      {
        x: 0,
        y: 8.66918,
      },
    ],
  },
  {
    bezier: [
      {
        x: 0,
        y: 13.4618,
      },
      {
        x: 8.79078,
        y: 26.8497,
      },
      {
        x: 8.79078,
        y: 26.8497,
      },
    ],
  },
  {
    bezier: [
      {
        x: 8.79078,
        y: 26.8497,
      },
      {
        x: 17.5816,
        y: 13.4618,
      },
      {
        x: 17.5816,
        y: 8.66918,
      },
    ],
  },
  {
    bezier: [
      {
        x: 17.5838,
        y: 7.52815,
      },
      {
        x: 17.3577,
        y: 6.39795,
      },
      {
        x: 16.9164,
        y: 5.34365,
      },
    ],
  },
  {
    bezier: [
      {
        x: 16.4751,
        y: 4.28935,
      },
      {
        x: 15.8273,
        y: 3.33177,
      },
      {
        x: 15.0103,
        y: 2.52603,
      },
    ],
  },
  {
    bezier: [
      {
        x: 14.1932,
        y: 1.72029,
      },
      {
        x: 13.2231,
        y: 1.0823,
      },
      {
        x: 12.1557,
        y: 0.648793,
      },
    ],
  },
  {
    bezier: [
      {
        x: 11.0883,
        y: 0.215288,
      },
      {
        x: 9.94469,
        y: -0.00517662,
      },
      {
        x: 8.79078,
        y: 0,
      },
    ],
  },
];
